// Instagram OAuth entry point, shared by the "connect" drawer and the
// "reconnect" prompts shown when a token expires.
//
// Extracted rather than duplicated: the client_id, redirect_uri and scope
// list must stay byte-identical across both surfaces. A reconnect that
// asks for a narrower scope than the original connect silently produces a
// token that cannot send DMs — the exact failure the prompt exists to fix.
//
// `auth_type=reauthenticate` + `prompt=consent` were already on the
// connect flow and are what make this work for reconnection: Meta
// re-issues a token even when the user is still logged in.

const INSTAGRAM_CLIENT_ID = '1035072877787285';
const INSTAGRAM_REDIRECT_URI = 'https://www.livelink.com.br/plugins/callback/instagram';
const INSTAGRAM_SCOPE = [
  'instagram_business_basic',
  'instagram_business_manage_comments',
  'instagram_business_manage_messages',
].join(',');

/** Builds the authorize URL. `state` is the caller's CSRF token. */
export function buildInstagramOauthUrl(state: string): string {
  const queryParams = [
    `client_id=${INSTAGRAM_CLIENT_ID}`,
    `redirect_uri=${INSTAGRAM_REDIRECT_URI}`,
    'response_type=code',
    'auth_type=reauthenticate',
    'prompt=consent',
    'display=popup',
  ];
  const base = `https://www.instagram.com/oauth/authorize?${queryParams.join('&')}`;
  return `${base}&state=${state}&scope=${INSTAGRAM_SCOPE}`;
}

/** Generates a CSRF token in the same shape the connect drawer uses. */
export function newOauthState(): string {
  return Math.random().toString(36).substring(2, 15);
}
